import React from "react";
import { Check, UserPlus } from "lucide-react";
import { BancontactQRSection } from "./BancontactQRSection";
import { MutuelleDownloadSection } from "./MutuelleDownloadSection";

export const RegistrationSuccess = ({ formData, emailSent, isExistingMemberUpdate }) => (
  <div className="wix-form-container">
    <div className="wix-card">
      <div className="wix-success-container">
        <img
          src="https://customer-assets.emergentagent.com/job_wix-form-replica/artifacts/8c7fc1k3_logofinal-logo-full-color-rgb-900px-w-72ppi.png"
          alt="B.health®"
          className="wix-logo-img"
          style={{ marginBottom: "24px" }}
        />
        <div className="wix-success-icon">
          {isExistingMemberUpdate ? (
            <UserPlus size={36} color="#3899ec" strokeWidth={3} />
          ) : (
            <Check size={36} color="#e8d44d" strokeWidth={3} />
          )}
        </div>
        <h2 className="wix-success-title">
          {isExistingMemberUpdate ? "Abonnement ajouté !" : "Inscription confirmée !"}
        </h2>

        {isExistingMemberUpdate && (
          <div className="wix-success-emails mb-4" style={{ backgroundColor: "#e8f4fd", borderColor: "#3899ec" }}>
            <div className="wix-success-email-row">
              <span className="wix-success-email-label" style={{ color: "#1a6bb0" }}>Info :</span>
              <span className="wix-success-email-value" style={{ color: "#1a6bb0" }}>
                Le membre existait déjà. Un nouvel abonnement a été ajouté à son profil.
              </span>
            </div>
          </div>
        )}

        {emailSent ? (
          <>
            <p className="wix-success-subtitle">
              {isExistingMemberUpdate
                ? "Le nouvel abonnement a été enregistré. Un email de confirmation a été envoyé."
                : "Votre inscription a bien été enregistrée. Un email de confirmation contenant votre fiche d'inscription et les Conditions Générales de Vente a été envoyé."}
            </p>
            <div className="wix-success-emails">
              <div className="wix-success-email-row">
                <span className="wix-success-email-label">À :</span>
                <span className="wix-success-email-value">{formData.email}</span>
              </div>
              <div className="wix-success-email-row">
                <span className="wix-success-email-label">Copies :</span>
                <span className="wix-success-email-value">{process.env.REACT_APP_CC_EMAILS}</span>
              </div>
            </div>
            <p className="text-sm text-[#577083] mt-4">
              Vérifiez votre boîte de réception ainsi que vos courriers indésirables.
            </p>
          </>
        ) : (
          <>
            <p className="wix-success-subtitle">
              {isExistingMemberUpdate
                ? "Le nouvel abonnement a été ajouté au profil du membre."
                : "Votre inscription a bien été enregistrée dans le système."}
            </p>
            <div className="wix-success-emails" style={{ backgroundColor: "#fff8e6", borderColor: "#e8d44d" }}>
              <div className="wix-success-email-row">
                <span className="wix-success-email-label" style={{ color: "#856404" }}>Note :</span>
                <span className="wix-success-email-value" style={{ color: "#856404" }}>Aucun email n'a été envoyé au client.</span>
              </div>
            </div>
            <p className="text-sm text-[#577083] mt-4">
              Vous pouvez envoyer l'email de confirmation ultérieurement depuis la fiche membre.
            </p>
          </>
        )}

        <BancontactQRSection className="mt-6" />
        <MutuelleDownloadSection mutuelle={formData.mutuelle} formData={formData} />
      </div>
    </div>
    <div className="wix-footer">
      <span className="wix-footer-text">B.health® — Tous droits réservés</span>
    </div>
  </div>
);
